import type { IconProps } from './types';

export const Pause = ({ size, ...props }: IconProps) => {
  const width = size && size > 0 ? size * 0.75 : 0;

  return (
    <svg width={width} height={size} viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="6" height="24" rx="1.5" fill="currentColor" />
      <rect x="12" width="6" height="24" rx="1.5" fill="currentColor" />
    </svg>
  );
};
